import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface SubtitleProps {
  text: string;
  format: string | undefined;
}

const formatToFontWeight = (format: string | undefined): string => {
  if (format === '10') {
    return '500';
  }
  return "400";
}

const Subtitle: React.FC<SubtitleProps> = ({ text, format }) => {
  // Explicitly handle the case where format is undefined
  const fontWeightValue = (format !== undefined && (format === "0" || format === "1" || format === "2")) ? "600" : (formatToFontWeight(format))
  const colorValue = (format !== undefined && (format === "0" || format === '10')) ? "brand.fontColors.third" : "brand.fontColors.primary";

  const classStyleText = (format !== undefined && (format === "0")) ? `margin-top-10` : '';

  return (
    <Box display="flex" alignItems="center" marginBottom='15px'>
      <Text fontSize="md" className={classStyleText} fontWeight={fontWeightValue} color={colorValue}>
        {text}
      </Text>
    </Box>
  );
};

export default Subtitle;
